/*
* @Author: yongwenhao
* @Date: 2020-10-13 09:50:11
* @describe: 列表
*/
<template>
    <div class='media-list'>
        <el-table :data="tableData" style="width: 100%">
            <el-table-column label="序号" type="index" width="100"></el-table-column>
            <el-table-column prop="partnerName" label="姓名" width="200" show-overflow-tooltip></el-table-column>
            <el-table-column prop="position" label="职位" width="200" show-overflow-tooltip></el-table-column>
            <el-table-column prop="email" label="邮箱" width="300" show-overflow-tooltip></el-table-column>
            <el-table-column prop="companyName" label="企业名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="productType" label="产品类型" show-overflow-tooltip></el-table-column>
            <el-table-column prop="indications" label="适应症" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createdTime" label="时间" width="180" show-overflow-tooltip></el-table-column>
            <el-table-column
                    fixed="right"
                    label="操作"
                    width="100">
                <template slot-scope="scope">
                    <el-button @click="onView(scope.row)" type="text" size="small">查看</el-button>
                    <el-button @click="onDel(scope.row)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <MediaDrawer v-model="isShow" :infoFrom="infoFrom"></MediaDrawer>
    </div>
</template>

<script>
    import MediaDrawer from './edit-add'
    import {GetMpList, DelMpId} from '../../api/media'
    import moment from "moment";

    export default {
        name: "media-list",
        props: {},
        components: {MediaDrawer},
        data() {
            return {
                tableData: [],
                isShow: false,
                infoFrom: {},
                params: {
                    pageNum: 1,
                    pageSize: 10000,
                    searchInfo: ''
                }
            }
        },
        methods: {
            init() {
                GetMpList().then(res => {
                    if (res.status) {
                        this.tableData = res.data.map(item => {
                            item.createdTime = moment(item.createdTime).format(
                                "YYYY-MM-DD HH:mm:ss"
                            );
                            return item;
                        });
                    }
                })
            },
            onView(params) {
                this.infoFrom = params;
                this.isShow = true
            },
            onDel(params) {
                this.$confirm("确认删除?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(() => {
                    DelMpId(params.mpId).then((res) => {
                        if (res.status) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });
                            this.init();
                        }
                    });
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消操作",
                    });
                });
            }
        },
        created() {
            this.init();
        }
    }
</script>

<style lang='less' scoped>
    .media-list {
        margin-top: 30px;
    }
</style>
